module.exports = __webpack_public_path__ + "media/components/Influencers/FormTags/Categories/19-11b8c4e1ddb94d4929ba4216bdf32f5b.png";